import { useSelector } from 'react-redux';

const useDiscounts = () => useSelector(state => state.discountsReducer.discounts);

const useDiscountsRange = () => useSelector(state => state.discountsReducer?.discountsRange || []);

export { useDiscounts, useDiscountsRange };
